import * as React from 'react';
import { FluentProvider, Theme } from '@fluentui/react-components';
import '@brand/tokens.css';
import { brandDarkTheme, brandLightTheme } from '@brand';

export const BrandProvider: React.FC<{ mode: 'light'|'dark'; children: React.ReactNode; }> = ({ mode, children }) => {
  const theme: Theme = mode === 'dark' ? brandDarkTheme : brandLightTheme;
  return <FluentProvider theme={theme} style={{ minHeight:'100dvh' }}>{children}</FluentProvider>;
};
